// extracted by mini-css-extract-plugin
export default {"root":"UrlList_root__ZQ-eo","item":"UrlList_item__dWOIl"};